export default __webpack_public_path__ + "static/media/inactiveContentManagement.9aad953d.svg";